export const LOCALES = {
  EN: "en",
  HE: "he",
  FR: "fr",
  RU: "ru",
};

const getDomainLocale = () => {
  if (typeof window === "undefined") return LOCALES.EN; // Default fallback

  const domain = window.location.hostname;

  if (domain.includes("rebbek.org") || domain.includes("rebbek.vercel.app")) {
    return LOCALES.HE;
  }
  return LOCALES.HE;
};

export const useLocale = () => {
  return getDomainLocale();
};
